import { isNotNullObject } from '../src/helpers/ObjectHelpers';
import SessionStorageService from './SessionStorageService';

export default class {
  static _getItem(key) {
    const storage = SessionStorageService.get(key);
    if (!isNotNullObject(storage)) {
      return {};
    }
    return storage;
  }


  static get(routeName) {
    const key = this._buildKey();
    const storage = this._getItem(key);
    return storage[routeName];
  }


  static set(routeName, { query, params }) {
    const key = this._buildKey();
    SessionStorageService.set(key, {
      ...this._getItem(key),
      [routeName]: { query, params },
    });
  }


  static _buildKey() {
    return `routerStorage::` + localStorage.getItem('parent');
  }

}
